import ReprintModal from '@/features/orders/components/OrderDetail/parts/Footer/ContextMenu/parts/ReprintModal'
import { useReprintModalPortal } from '@/features/orders/components/OrderDetail/parts/Footer/ContextMenu/parts/ReprintModal/contexts/Portal'
import { useState } from 'react'

type ShowFunction = () => void

export const useReprintModal = (orderUuid: string): ShowFunction => {
    const [visible, setVisible] = useState(false)

    const show: ShowFunction = () => {
        setVisible(true)
    }

    const hide = () => {
        setVisible(false)
    }

    useReprintModalPortal(visible, <ReprintModal orderUuid={orderUuid} onDismiss={hide} />)

    return show
}
